import axios from 'axios'
import { StaticImage } from 'gatsby-plugin-image'
import { withTranslation } from 'gatsby-plugin-react-i18next'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import LocationSearch from '../../location-search/LocationSearch'
import "./Hero.css"

const background = {
  src: '../../../images/hero.jpg',
  alt: 'Storage units with yellow sliding doors'
}

// Specify the locations (by their _id) that the hero
// will show links to. Non-array values (e.g. null) will result
// in links to all locations being shown.
const locationsFilter = null
// process.env.NODE_ENV === 'development' 
//   ? ['5fd4b8aef035c9b70da8fddb', '5fd4b8e1f035c9b70da8fdde', '5fd4c7c1b63cc6bd0d592ef9', '6089f0ad4f3af53408f965f3']
//   : ['5fde3331418abbc5b319b40f', '5fde338d418abbc5b319b412', '5fde33e1418abbc5b319b415', '608efe8cb1238f000ace2d59']

// Specify the number of location links to show per row,
// e.g. [3, 2] would mean show 2 rows, the first with 
// 3 location links, and the second with 2 location links
const locationRowCounts = [3, 2]

class Hero extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    const { t, locations } = this.props
    const locationsArr = Object.values(locations) 
    // If locationsFilter is specified (on top) and is an array,
    // then filter out only the locations specified in locationsFilter,
    // otherwise keep all locations
    let filteredLocations = Array.isArray(locationsFilter) 
      ? locationsArr.filter(location => locationsFilter.includes(location._id))
      : locationsArr
        
    // If locationRowCounts is specified (on top)and is an array,
    // then split the location array into rows with the specified counts,
    // otherwise show everything in one row
    const locationRows = Array.isArray(locationRowCounts) 
      ? filteredLocations && locationRowCounts.map((rowCount, ind) => {
        const startIndex = locationRowCounts.slice(0, ind).reduce((cur, acc) => acc + cur, 0)
        const endIndex = startIndex + rowCount
        return filteredLocations.slice(startIndex, endIndex)
      })
      : [filteredLocations]
      
    return (
      <div className="home-hero-wrap">
        <StaticImage 
          className="hh-background"
          loading="eager" 
          objectPosition="top"
          {...background} 
        />
        <h1 className="home-hero-title">{t(`landing:hero.head`)}</h1>
        <div className="hh-search-wrap">
          <LocationSearch showButton rounded />
        </div>
        <div className="hh-location-links-wrap">
          {locationRows && locationRows.map((row, ind) => {
            return (
              <div className="hh-location-links-row" key={ind}>
                {row && row.map(location => {
                  if (location.address) {
                    return (
                      <a
                        key={location._id}
                        href={`/location/${location.url_name}`}
                        className="button hh-location-link">
                        {`${location.address.city}, ${location.address.state}`}
                      </a>
                    )
                  }
                  return null
                })}
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  locations: state.bookingsReservations.locations
})
export default connect(
  mapStateToProps,
  null
)(withTranslation(['landing'])(Hero))
